import { useState, useCallback } from 'react';
import {
    fetchAnalyticsFromDb,
    type AnalyticsParams,
    type AnalyticsResponse,
} from '../services/analyticsService';
import {getErrorMessage} from "../utils/errors.ts";

export function useAnalytics() {
    const [data,    setData]    = useState<AnalyticsResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error,   setError]   = useState<string | null>(null);

    const fetchAnalytics = useCallback(async (
        params: AnalyticsParams
    ): Promise<AnalyticsResponse | null> => {
        setLoading(true);
        setError(null);
        try {
            const result = await fetchAnalyticsFromDb(params);
            setData(result);
            return result;
        } catch (err) {
            setError(getErrorMessage(err, 'Failed to load analytics'));
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        data,
        loading,
        error,
        fetchAnalytics,
    };
}